

import { Point } from '../../../platform/geom/Point';
import { MouseButtons, MouseInput } from '../../../platform/input/MouseInput';
import { resolve } from '../../Container';
import { ToolBehavior } from '../tooling/ToolBehavior';
import { WidgetManager } from '../workspace/widgets/WidgetManager';
import { ContextMenuWidget } from './ContextMenuWidget';

export class ContextMenuToolBehavior extends ToolBehavior {

    @resolve(WidgetManager) private widgets: WidgetManager;

    private mouseDownAt = null as Point;

    constructor() {
        super();
        this.burden(() => this.cancelContextMenu());
    }

    public onMouseDown(state: string, e: MouseInput): string | void {
        this.cancelContextMenu();
        if (e.button === MouseButtons.Secondary) {
            this.mouseDownAt = e.position;
        }
    }

    public onMouseUp(state: string, e: MouseInput): string | void {
        if (state === 'idle' && e.button === MouseButtons.Secondary && this.mouseDownAt) {
            const dist = this.mouseDownAt.distanceTo(e.position);
            if (dist <= 2) {
                setTimeout(() => this.realizeContextMenu(e.position), 1);
            }
            this.mouseDownAt = null;
        }
    }

    private realizeContextMenu(at: Point) {
        this.cancelContextMenu();
        const mount = this.widgets.createContainer({
            name: 'context',
            position: ['absolute', { at, relativeTo: 'view', zOrder: 200 }],
            style: 'floatHover',
        });
        mount.add(this.widgets.createInline({
            position: at,
            ui: ContextMenuWidget,
            onClose: () => this.widgets.delete('context'),
        }));
        this.widgets.add(mount);
    }

    private cancelContextMenu() {
        this.widgets.delete('context');
    }
}
